// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing197({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "1c859ebc-01eb-4654-8d6e-8fa9b2048a65", label: "정밀진단 무료" },
    { value: "fa56f042-7bda-433c-9b89-d3b26dace31a", label: "치아교정 250만원" },
  ];
  return (
    <>
      <RandingStyle4
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/197/1.png`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/197/2.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton.png`}
        qOptionColor="blue"
        formFieldColor="white"
        benefitInfoPosition="top"
        companyName="검단뉴욕치과의원"
        footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan.png`}
        periodType="month"
        treatments={treatments}
      />
    </>
  );
}

export default Randing197;
